import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import "./Login.css";
import { Separator } from "./Login.style";
import { HeaderPrimary } from "../../components/HeaderText/HeaderText.style";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { UserContext } from "../../providers/UserProvider";
import {
    authService,
    v1TaglessService,
    apiClient,
} from "../../services/Services";
import { AuthChallenge } from "../../types/Auth";
import NewPasswordForm from "../../components/auth/NewPasswordForm";

export default function Login({ setErrorState }) {
    const { setUserDetails } = useContext(UserContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showNewPasswordForm, setShowNewPasswordForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [newPasswordError, setNewPasswordError] = useState("");
    const navigate = useNavigate("");

    const validateForm = () => {
        return username.length > 0 && password.length > 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        authService
            .login(username, password)
            .then((result) => {
                if (result.success) {
                    // Successful login
                    v1TaglessService.updateBearerToken(
                        authService.getIdentityToken(),
                    );
                    apiClient.updateBearerToken();
                    setUserDetails({ username: username });
                    navigate("/");
                } else if (
                    result.challengeData?.challenge ===
                    AuthChallenge.NEW_PASSWORD_REQUIRED
                ) {
                    // Need to set new password
                    setShowNewPasswordForm(true);
                }
                setLoading(false);
            })
            .catch((reason) => {
                setLoading(false);
                setErrorState({
                    hasError: true,
                    message: reason.message,
                });
            });
    };

    const handleNewPasswordSubmit = async (newPassword) => {
        setLoading(true);
        setNewPasswordError("");

        try {
            await authService.completeNewPassword(newPassword);
            // After successful password change, complete the login flow
            v1TaglessService.updateBearerToken(authService.getIdentityToken());
            apiClient.updateBearerToken();
            setUserDetails({ username: username });
            navigate("/");
        } catch (error) {
            setNewPasswordError(error.message || "Failed to set new password");
        } finally {
            setLoading(false);
        }
    };

    // detect that user is already logged or not, if logged navigate to home page.
    useEffect(() => {
        if (authService.getIdentityToken() !== null) {
            navigate("/");
        }
    }, [navigate]);

    // If we need to show the new password form, render it instead
    if (showNewPasswordForm) {
        return (
            <NewPasswordForm
                onSubmit={handleNewPasswordSubmit}
                loading={loading}
                error={newPasswordError}
            />
        );
    }

    return (
        <Container className="LoginContainer">
            <br />
            <Form onSubmit={handleSubmit} className="LoginForm">
                <HeaderPrimary>Sign In</HeaderPrimary>
                <br />
                <br />
                <Box display="flex" justifyContent="center">
                    <TextField
                        label="Username"
                        type="text"
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </Box>
                <Separator />
                <Box display="flex" justifyContent="center">
                    <TextField
                        id="outlined-password-input"
                        label="Password"
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </Box>
                <br />
                {/* <PrimaryButton type="submit" disabled={!validateForm()} text="Login" onSubmit={authenticate(username, password)}/> */}
                <Box display="flex" justifyContent="center">
                    <Button
                        variant="contained"
                        sx={{
                            bgcolor: "#043c4a",
                            height: "50px",
                            width: "50px",
                            color: "#ffffff",
                            ":hover": {
                                bgcolor: "#043c4a",
                            },
                        }}
                        disabled={!validateForm() || loading}
                        type="submit"
                        className="PrimaryBtn"
                    >
                        {loading ? "Signing In..." : "Login"}
                    </Button>
                </Box>
                <Separator />
            </Form>
        </Container>
    );
}
